import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isMobileDevice(): boolean {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

export function getWhatsAppUrl(phone: string): string {
  if (isMobileDevice()) {
    return `whatsapp://send?phone=${phone}`;
  }
  return `https://web.whatsapp.com/send?phone=${phone}`;
}

export function getWhatsAppGroupUrl(inviteCode: string): string {
  if (isMobileDevice()) {
    return `https://chat.whatsapp.com/${inviteCode}`;
  }
  return `https://web.whatsapp.com/accept?code=${inviteCode}`;
}
